import React from 'react';
import { ArrowUp } from 'lucide-react';
export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-gray-900 text-white py-12" data-id="element-100">
      <div className="container mx-auto px-4 md:px-6" data-id="element-101">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-102">
          <div className="mb-6 md:mb-0" data-id="element-103">
            <a href="#" className="text-2xl font-bold" data-id="element-104">
              <span className="text-indigo-400" data-id="element-105">OTO</span> PR9
            </a>
            <p className="mt-2 text-gray-400 max-w-md" data-id="element-106">
              Creating innovative digital experiences and mobile applications
              that connect people with opportunities in real-time.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-end" data-id="element-107">
            <button onClick={scrollToTop} className="bg-indigo-600 hover:bg-indigo-700 p-3 rounded-full transition-colors mb-4" aria-label="Scroll to top" data-id="element-108">
              <ArrowUp size={20} data-id="element-109" />
            </button>
            <p className="text-gray-400 text-sm" data-id="element-110">
              © {new Date().getFullYear()} OTO PR9. All rights reserved.
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-111">
          <nav className="flex flex-wrap justify-center md:justify-start gap-6 mb-6 md:mb-0" data-id="element-112">
            {['Home', 'About', 'Skills', 'Projects', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors" data-id="element-113">
                {item}
              </a>)}
          </nav>
          <div className="flex space-x-4" data-id="element-114">
            {['twitter', 'linkedin', 'dribbble', 'behance'].map(platform => <a key={platform} href="#" className="text-gray-400 hover:text-white transition-colors" aria-label={`Visit my ${platform} profile`} data-id="element-115"></a>)}
          </div>
        </div>
      </div>
    </footer>;
};